import { Button, Collapse, Flex, List, ListItem, Paper, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';

import { ImportState } from '@/module/Sync/model/SyncTypes';

interface AlreadyImportedProps {
  list: ImportState[];
}

export function AlreadyImported({ list }: AlreadyImportedProps) {
  const [opened, { toggle }] = useDisclosure(false);
  const { t } = useTranslation();

  return (
    <Paper p="md">
      <Flex
        mb="15px"
        align="center"
        justify="space-between"
      >
        <Text fw="500">{t('sync.alreadyImported', { count: list.length })}</Text>
        <Button
          variant="outline"
          size="xs"
          onClick={toggle}
        >
          {!opened ? t('sync.showAlreadyImported') : t('sync.hideAlreadyImported')}
        </Button>
      </Flex>
      <Collapse in={opened}>
        <List>
          {list.map(({ item }) => (
            <ListItem>{item.title}</ListItem>
          ))}
        </List>
      </Collapse>
    </Paper>
  );
}
